export const REFUNDSTATUS = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  CANCELED: 'CANCELED',
} as const;

export const NATIONALITY_GUIDE_LIST = [
  { label: '중국', value: 'CHN' },
  { label: '일본', value: 'JPN' },
  { label: '미국', value: 'USA' },
  { label: '대만', value: 'TWN' },
  { label: '대한민국', value: 'KOR' },
];
